<template>
  <div class="profile-page">
    <div class="flex flex-wrap">
    <Image class="flex flex-wrap border-solid m-4" src="https://ztchecvzbsazdgbkuzzp.supabase.co/storage/v1/object/public/media-storage-bucket/red_panda.jpeg" alt="Image" width="250" />
          <div class="block m-4 text-left">
             <h1 >{{ profile.user_metadata.full_name }}</h1>
             <p >joined on {{profile.created_at.substring(0,10)}}</p>
              <p >last seen {{profile.updated_at.substring(0,10)}}</p>
          </div>
           <a v-ripple class="flex align-items-up cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple ml-8 m-4">
                                    <i class="pi pi-pencil mr-2"></i>
                                    <span class="font-medium">Edit Profile</span>
            </a>
    </div>
      
    <Divider />
    <TabView>
    <TabPanel header="Certificates">
        <ul class="list-none p-0 m-0 overflow-hidden">
                            <li>
                                <a v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-trophy mr-2"></i>
                                    <span @click="createPDF" class="font-medium">Download Certificate</span>
                                </a>
                            </li>
                            <li>
                                <a v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-bookmark mr-2"></i>
                                    <span class="font-medium">Whatever bruh</span>
                                </a>
                            </li>
            </ul> 
    </TabPanel>
    <TabPanel header="Header">
        <p class="m-0">
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim
            ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius modi.
        </p>
    </TabPanel>
    <TabPanel header="Account">
            <ul class="list-none p-0 m-0 overflow-hidden">
                            <li>
                                <a v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-sign-out mr-2"></i>
                                    <span @click="signout" class="font-medium">Signout</span>
                                </a>
                            </li>
                            <li>
                                <a v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                                    <i class="pi pi-bookmark mr-2"></i>
                                    <span class="font-medium">Bookmarks</span>
                                </a>
                            </li>
            </ul> 
    </TabPanel>
    </TabView>



   

      
      
  </div>
</template>

<script>
import { supabase } from '@/supabase.js'
import jsPDF from 'jspdf'
import Image from 'primevue/image';
import Divider from 'primevue/divider';
//import Button from 'primevue/button';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';



export default {
   components: {
 Image,
  Divider,
  TabView,
  TabPanel
 
   },
  data() {
    return {
      profile:{},
      menu_items:["Courses","Account","Certificates"],
    };
  },
  async created() {
   const { data:{user}} = await supabase.auth.getUser()
          this.profile=user;

  },
  methods: {
   async signout (){
      let { error } = await supabase.auth.signOut()
      console.log(error)
      this.$router.push(`/`);
    },
    createPDF () {
    let pdfName = 'test'; 
    var doc = new jsPDF();
    const certname= this.profile.user_metadata.full_name
    doc.text(certname, 10, 10);
    doc.save(pdfName + '.pdf');
  }

  }
 
};
</script>

<style scoped>
/* Add your styling here */
.profile-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  justify-content: center; /* Horizontally center content */
}

.profile-header {
  text-align: center;
  margin-bottom: 20px;
}

.profile-picture {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 10px;
}

h1 {
  margin: 0;
  color: #333;
}

.profile-form {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

h2 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #555;
}

input {
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* button {
  width: 100%;
  padding: 12px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
  transition: background-color 0.3s;
} */

button:hover {
  background-color: #45a049;
}
</style>
